import React, { useContext } from 'react'
import { useQuery } from '@apollo/react-hooks'
import get from 'lodash/get'
import { Col } from 'antd'

import Portfolio from '../Portfolio'
import { AppContext } from 'AppContext'
import { GET_DASHBOARD_SIP_AMC_CLIENT } from 'modules/Dashboard/graphql/Queries'

export default function ({ clientId }) {
  const { state: { currentUser: { id }, selectedStrategy } } = useContext(AppContext)
  const { data, loading } = useQuery(GET_DASHBOARD_SIP_AMC_CLIENT, { variables: { where: { userId: parseInt(clientId || id), strategyCode: selectedStrategy } }, fetchPolicy: 'network-only' })
  if (loading || !get(data, 'spDashbordSIPAMCClient') || !get(data, 'spDashbordSIPAMCClient')[0] || !get(data, 'spDashbordSIPAMCClient')[1]) return <></>

  return (
    <>
      <Col xl={12} lg={12} md={12} sm={24} xs={24}>
        <Portfolio isClient={!!clientId} type='AMC' {...get(data, 'spDashbordSIPAMCClient')[1]} />
      </Col>
      <Col xl={12} lg={12} md={12} sm={24} xs={24}>
        <Portfolio isClient={!!clientId} {...get(data, 'spDashbordSIPAMCClient')[0]} />
      </Col>
    </>
  )
}
